define(function (require) {
	"use strict";
	var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
	var CsatEditView = require("personalization-web-agent-views/CsatEditView");
	var Settings = require("codeTables/settings.json");
    var ERROR_CODES = require("codeTables/errorCodes.json");
	var CsatEditController={};

	LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
		CsatEditController = BaseFeatureController.extend({
			initialize: function (options) {
				LEPersonalization.logger.info("initializing", "CsatEditController:initialize. options = " + options);
                this.siteSettingsModel = options.siteSettingsModel;
				this.csatEditView = new CsatEditView({
					anchorSelector: options.featureOptions.anchorSelector,
                    siteSettingsModel: options.siteSettingsModel
				});
				this.listenTo(this.csatEditView,"csat:save",this._save,this);
			},

			getEditView:function(options){
				LEPersonalization.logger.debug("return this view", "CsatEditController:getEditView. options = " + options);
				return this.csatEditView;
			},

			_save:function(options){
				LEPersonalization.logger.debug("save site settings", "CsatEditController:_saveSiteSettings.");
				LEPersonalization.loader.setLoader();
				options = options || [];
                this.siteSettingsModel.setValue(options[Settings.SETTING_ID.CSAT_AGENT_VIEW]);
                this.siteSettingsModel.save(null,{
					success: _.bind(this._onSaveSuccess, this),
					error: _.bind(this._onSaveError, this)
				});
			},
            _showNotifierError: function(response) {
                if(response && response.responseError && response.responseError.code === ERROR_CODES.wrongRevision) {
                    LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1001"));
                } else {
                    LEPersonalization.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
                }
            },

			_onSaveSuccess: function (model, response, options) {
				LEPersonalization.logger.debug("When data fetch was successful", "CsatEditController:_onSaveSuccess. response = " + response);
				LEPersonalization.loader.closeLoader();
				LEPersonalization.navigateToPageMenu();
			},
			_onSaveError: function (model, response, options) {
				LEPersonalization.logger.debug("When data fetch has resulted with an error", "CsatEditController:_onSaveError. response = " + response);
                this._showNotifierError(response);
				LEPersonalization.loader.closeLoader();
			}
		});
	});
	return CsatEditController;

});
